// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./components/App/App";

// Global styles
import "./styles/theme.css";
import "./styles/layout.css";
import "./styles/forms.css";
import "./styles/cards.css";
import "./styles/sidebar.css";
import "./styles/buttons.css";
import "./styles/typography.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .then((registration) => {
        console.info(
          "Doctor Is In App service worker registered:",
          registration.scope
        );
      })
      .catch((error) => {
        console.error(
          "Doctor Is In App service worker registration failed:",
          error
        );
      });
  });
}
